"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesZipIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><path fill="inherit" d="M9 7c0-.55.44-1 1-1h2v3h-2a1 1 0 0 1-1-1zm3 2h2c.55 0 1 .44 1 1v1a1 1 0 0 1-1 1h-2zm-3 4c0-.55.44-1 1-1h2v3h-2a1 1 0 0 1-1-1zm3 2h2c.55 0 1 .44 1 1v1a1 1 0 0 1-1 1h-2z"/></g></svg>`
}, props));
MediaServicesZipIcon.displayName = 'MediaServicesZipIcon';
var _default = exports.default = MediaServicesZipIcon;